module.exports = __webpack_public_path__ + "static/media/return_sound.e68b9dc6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/return_sound.mp3
// module id = 396
// module chunks = 0